import { SituacaoRestrictEnumEPC } from "../enums/Enumarations";
import { Router, ActivatedRoute } from "@angular/router";
import { PadraoService } from "../../../service/padrao.service";
import { OnInit } from "@angular/core";
import { ObservableUtil, bObservableUsuario, ObservableBlockPanel } from "../../../util/observable-util";
import { Message } from "primeng/components/common/message";
import { ConfirmationService } from "primeng/primeng";
/**
 * Construtor padrão para o sistema, todas implementações devem refletir esse construtor
 */
export interface SistemaConstrutor {
    new(
        router: Router,
        activatedRoute: ActivatedRoute,
        service: PadraoService,
        confirmacao: ConfirmationService,
        msgs: Message[],
        bObservable: bObservableUsuario,
        observableUtilPanel: ObservableBlockPanel
    );
}
/**
 * Interface para criação dos métodos sistemas que serão usado para especificar cada ação única do sistema referente.
 */
export interface ISistema extends OnInit {
    /**
     *
     */
    ngOnInit();
    /**
     * Lotação atual do usuário
     */
    perfilLotado: any;
    /**
     * Enumeraveis de situacao usados para restrição do usuário
     */
    situacaoRestric: any;
    /**
     * Enumeraveis de situacao usados para restrição do usuário
     */
    situacaoAlter: any;
    /**
     * Enumeraveis do perfil usados para restrição do usuário
     */
    perfilRestrict: any;
    /**
     * Componentes do menu de cada sistema, deve ser definido na implementação de cada sistema.
     */
    componentsAppMenu: any;
    /**
     * Variaveis para ser usada para comparação do sistema, a ser definido na classe de implementação de cada sistema.
     */
    variableComparable: any;
    /**
     * Objeto de configuração para geração do relatório
     */
    reportConfig: any;
    /**
     * Metodo a ser definido na classe filha de acordo com a necessidade do sistema que implementa essa interface.
     * @param value1 
     * @param value2 
     * @param value3 
     * @param value4 
     * @param value5 
     * @param value6 
     * @param value7 
     * @param value8 
     * @param value9 
     * @param value10 
     */
    undefinedMethod(value1?: any, value2?: any, value3?: any, value4?: any, value5?: any
        , value6?: any, value7?: any, value8?: any, value9?: any, value10?: any);
    /**
     * Método que define as ações especificas da datatable de cada sistema.
     * @param value1 
     * @param value2 
     * @param value3 
     * @param value4 
     * @param value5 
     * @param value6 
     * @param value7 
     * @param value8 
     * @param value9 
     * @param value10 
     */
    dataTableFunction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any);
    /**
     * Método que define as ações específicas para cada novo case do base list.
     * @param event 
     * @param controllerName 
     * @param filtro 
     * @param situacao 
     * @param listagem 
     * @param value6 
     * @param value7 
     * @param value8 
     * @param value9 
     * @param value10 
     */
    dataTableAction(event?: any, controllerName?: any, filtro?: any, situacao?: any, listagem?: any,
        value6?: any, value7?: any, value8?: any, value9?: any, value10?: any);
    showMsg(severity: string, summary: string, detail: string);
    validAction(value1: any);
}
/**
 * Criar uma instancia das classas concretas que implementam a interface ISistema contendo um construtor obrigatório
 */
export function CriarSistema(
    construtor: SistemaConstrutor,
    router: Router,
    activatedRoute: ActivatedRoute,
    service: PadraoService,
    confirmacao: ConfirmationService,
    msgs: Message[],
    bObservable: bObservableUsuario,
    observableUtilPanel: ObservableBlockPanel
): ISistema {
    return new construtor(router, activatedRoute, service, confirmacao, msgs, bObservable, observableUtilPanel);
}



// WEBPACK FOOTER //
// ./src/app/base/use-system/interface-system/system-interface.ts